import { ApiOrderType, type OrderResponse } from '@/core/generated/api';

/** Определяет покупку абонемента по типу заказа, независимо от способа оплаты услуги */
export const isSubscriptionPurchase = (order: OrderResponse): boolean =>
    order.orderType?.id === ApiOrderType.Subscription;
